// src/components/WebsiteChanges/ChangesInWebsite.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const ChangesInWebsite = () => {
  const navigate = useNavigate();

  // State for selected change type
  const [changeType, setChangeType] = useState('');

  // Options for changes
  const changeOptions = [
    { value: 'HomBannerChanges', label: '🏠 Home Banner Changes Update' },
    { value: 'CategoryChanges', label: '📂 Category Changes Update' },
    { value: 'TopSellingProductsBanner', label: '🔥 Top Selling Products Banner Update' },
    { value: 'TopFeaturedProductsRollingText', label: '🔄 Top Featured Products Rolling Text Update' },
    { value: 'SponsorPage', label: '🤝 Sponsor Page Update' },
  ];

  const handleChange = (e) => {
    setChangeType(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Navigate to the corresponding update page based on the selected change type
    navigate(`/admin/${changeType}`);
  };

  return (
    <div className="relative flex justify-center items-center min-h-screen bg-gradient-to-br from-green-300 to-blue-300 p-6 overflow-hidden">
      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        {/* Vertical Decorative Lines */}
        <div className="absolute border-l-4 border-blue-600" style={{ top: '10%', left: '0%', height: '80%' }}></div>
        <div className="absolute border-l-4 border-blue-600" style={{ top: '10%', left: '20%', height: '80%' }}></div>
        <div className="absolute border-l-4 border-blue-600" style={{ top: '10%', left: '40%', height: '80%' }}></div>
        <div className="absolute border-l-4 border-blue-800" style={{ top: '10%', left: '60%', height: '80%' }}></div>
        <div className="absolute border-l-4 border-blue-600" style={{ top: '10%', left: '80%', height: '80%' }}></div>
        <div className="absolute border-l-4 border-blue-600" style={{ top: '10%', left: '100%', height: '80%' }}></div>


        {/* Horizontal Decorative Lines */}
        <div className="absolute border-t-4 border-blue-600" style={{ top: '10%', left: '10%', width: '80%' }}></div>
        <div className="absolute border-t-4 border-blue-800" style={{ top: '30%', left: '10%', width: '80%' }}></div>
        <div className="absolute border-t-4 border-blue-600" style={{ top: '50%', left: '10%', width: '80%' }}></div>
        <div className="absolute border-t-4 border-blue-800" style={{ top: '70%', left: '10%', width: '80%' }}></div>
      </div>

      <motion.div
        className="bg-white shadow-lg rounded-3xl p-10 w-full max-w-lg z-10 transform transition-all duration-500 hover:shadow-xl"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      >
        <h2 className="text-4xl font-bold text-center text-blue-700 mb-8 tracking-wide">
          🌟 Select Changes to Apply
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="mb-6">
            <label className="block mb-2 text-gray-800 font-semibold" htmlFor="changeType">
              What type of changes apply to the website?
            </label>
            <select
              id="changeType"
              name="changeType"
              value={changeType}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-green-600 transition duration-300 transform hover:scale-105"
            >
              <option value="" disabled>Select an option</option>
              {changeOptions.map((option) => (
                <option key={option.value} value={option.value} className="text-gray-700 hover:bg-green-100">
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <motion.button
            type="submit"
            className={`w-full bg-blue-600 text-white font-bold px-4 py-2 rounded-lg shadow transition duration-200 hover:bg-green-700 ${
              !changeType ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-lg'
            }`}
            disabled={!changeType} // Disable the button if no option is selected
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Apply Changes
          </motion.button>
        </form>
        <p className="mt-4 text-center text-gray-500">
          📝 Make your selections and click the button to apply the changes!
        </p>
      </motion.div>
    </div>
  );
};

export default ChangesInWebsite;
